import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { savePropertyManagementSettings } from 'bundles/backoffice/royalty_settings/store/property_management/actions';

import Modal from 'components/modal';
import Button from 'shared/button';
import ManagedInput from 'components/form/managed_input';
import ManagedFormGroup from 'components/form/managed_input/form_group';

export function PropertyManagementModal({
  allowDeals,
  royaltyPercent,
  savePropertyManagementSettings,
  saving,
  show,
  onClose
}) {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    if (show) {
      setSettings({ allowDeals, royaltyPercent });
    }
  }, [allowDeals, royaltyPercent, show]);

  useEffect(() => {
    if (!saving) {
      onClose();
    }
  }, [saving]);

  const handleChange = (changes) => {
    setSettings({ ...settings, ...changes });
  };

  const handleSave = () => {
    savePropertyManagementSettings(settings);
  };

  return (
    <Modal
      backdrop="static"
      className="form-modal visible-overflow"
      show={show}
      onCancel={onClose}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        Property Management
      </Modal.Header>

      <Modal.Body>
        <div className="form form-horizontal">
          <h4>Enable or Disable</h4>
          <ManagedInput
            name="allowDeals"
            type="checkbox"
            value={settings.allowDeals}
            onChange={handleChange}
          >
            Check if this company can do property management transactions
          </ManagedInput>

          <ManagedFormGroup
            className="mt-4"
            label="Royalty Percent"
            name="royaltyPercent"
            type="number"
            value={settings.royaltyPercent}
            onChange={handleChange}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel name="cancel" onClick={onClose} />
        <Button.Primary disabled={saving} name="save" onClick={handleSave}>Save</Button.Primary>
      </Modal.Footer>
    </Modal>
  );
}

PropertyManagementModal.propTypes = {
  allowDeals: PropTypes.bool,
  royaltyPercent: PropTypes.number,
  savePropertyManagementSettings: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = ({ propertyManagement }) => ({
  allowDeals: propertyManagement.allowDeals,
  royaltyPercent: propertyManagement.royaltyPercent,
  saving: propertyManagement.saving,
});

const mapDispatchToProps = {
  savePropertyManagementSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertyManagementModal);
